import { render, staticRenderFns } from "./EditServer.vue?vue&type=template&id=247e8791&"
import script from "./EditServer.vue?vue&type=script&lang=ts&"
export * from "./EditServer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports